<template>
  <div class="kongjian">
    <a-row style="height: 100%">
      <a-col :span="17" style="height: 100%">
        <ShowWpsFile
          ref="showWpsFile"
          :btnShow="false"
          :fileCode="code"
          :isReadOnly="'true'"
        />
      </a-col>
      <a-col :span="7">
        <a-row class="op-row">
          <a-col :span="8" class="title"> 年份：</a-col>
          <a-col :span="14">
            <a-select
              style="width: 100%"
              v-model="suggestYear"
              @change="getPublishPlan"
            >
              <a-select-option
                v-for="item in yearList"
                :key="item"
                :value="item"
              >
                {{ item }}
              </a-select-option>
            </a-select>
          </a-col>
        </a-row>
        <a-row class="op-row">
          <a-col :span="8" class="title"> 建议期次：</a-col>
          <a-col :span="14">
            <a-select style="width: 100%" v-model="suggestPlan">
              <a-select-option
                v-for="item in planList"
                :key="item.total"
                :value="item.total"
              >
                {{ `总第${item.total}期` }}
              </a-select-option>
            </a-select>
          </a-col>
        </a-row>
        <a-row class="op-row">
          <a-col :span="8" class="title"> 版本：</a-col>
          <a-col :span="14">
            <a-select
              style="width: 100%"
              v-model="sectionInfo"
              @change="onSectionInfoChange"
            >
              <a-select-option
                v-for="item in sectionInfos"
                :value="item.dicValue"
                :key="item.dicValue"
              >
                {{ item.dicValue }}
              </a-select-option>
            </a-select>
          </a-col>
        </a-row>
        <a-row class="op-row">
          <a-col :span="8" class="title"> 建议栏目：</a-col>
          <a-col :span="14">
            <a-select style="width: 100%" v-model="suggestColumn">
              <a-select-option
                v-for="item in columnList"
                :key="item.columnCode"
                :value="item.columnCode"
              >
                {{ item.columnName }}
              </a-select-option>
            </a-select>
          </a-col>
        </a-row>
        <a-row class="op-row">
          <a-col :span="8" class="title">中图分类号：</a-col>
          <a-col :span="14">
            <a-input v-model="extraInfo.cnNo" />
          </a-col>
        </a-row>
        <a-row class="op-row">
          <a-col :span="8" class="title">文章标识码：</a-col>
          <a-col :span="14">
            <a-input v-model="extraInfo.articleType" />
          </a-col>
        </a-row>
        <a-row class="op-row">
          <a-col :span="8" class="title">文章编号：</a-col>
          <a-col :span="14">
            <a-input v-model="extraInfo.articleNo" />
          </a-col>
        </a-row>
        <div class="btn_div">
          <a-row>
            <a-button id="cancel" name="btn" @click="cancel"> 关闭 </a-button>
            <a-button id="save" name="btn" @click="save"> 保存 </a-button>
          </a-row>
        </div>
      </a-col>
    </a-row>
  </div>
</template>

<script>
import qs from "qs";
import moment from "moment";
import ShowWpsFile from "../../../commomon/ShowWpsFile.vue";
export default {
  name: "BackManager",
  data() {
    return {
      showBoxHeight: document.body.clientHeight - 115 + "px",
      code: "",
      info: {},
      currAuditStatus: 0,
      serviceAddress: this.$config.serviceAddress,
      yearList: [],
      planList: [],
      columnList: [],
      suggestYear: "",
      suggestPlan: "",
      suggestColumn: "",
      sectionInfo: "",
      suggestId: 0,
      sectionInfos: [],
      extraInfo: {
        cnNo: "",
        articleType: "",
        articleNo: "",
      },
    };
  },
  components: {
    ShowWpsFile,
  },
  created() {
    this.code = this.$route.query.code;
    this.currAuditStatus = this.$route.query.auditStatus; // 稿件当前审核状态
    this.suggestYear = new Date().getFullYear().toString();
    this.axios
      .get("/manuscripts/queryByCode", {
        params: {
          code: this.code,
          time: new Date().getTime(),
        },
        paramsSerializer: function (p) {
          return qs.stringify(p, { arrayFormat: "repeat" });
        },
      })
      .then((res) => {
        if (res.data.code == "OK") {
          this.info = res.data.data;
          this.sectionInfo = this.info.sectionInfo;
          this.getColumnList(this.sectionInfo);
          this.extraInfo.cnNo = this.info.cnNo;
          this.extraInfo.articleType = this.info.articleType;
          this.extraInfo.articleNo = this.info.articleNo;
        } else {
          this.utils.messageInfo(this, "error", "查询稿件失败！");
        }
      });
    this.axios.get("/publishPlan/queryYear").then((res) => {
      this.yearList = res.data;
    });
    this.axios
      .get("/dataDic/queryChild", { params: { parentCode: "section_info" } })
      .then((res) => {
        if (res.data) {
          this.sectionInfos = res.data;
        } else {
          this.utils.messageInfo(this, "error", "查询刊物版本失败！");
        }
      });
    this.getPublishPlan();
    this.getSuggest();
  },
  mounted() {},
  methods: {
    moment,
    cancel() {
      this.$router.push("/back");
    },
    onSectionInfoChange(val) {
      this.sectionInfo = val;
      this.getColumnList(val);
    },
    getColumnList(sectionInfo) {
      this.axios
        .get("/columnInfo/queryColumnInfo", {
          params: {
            sortField: "create_time",
            sortType: "asc",
            sectionInfo: sectionInfo,
            page: 1,
            limit: 100,
            time: new Date().getTime(),
          },
          paramsSerializer: function (p) {
            return qs.stringify(p, { arrayFormat: "repeat" });
          },
        })
        .then((res) => {
          if (res.data.code == "0") {
            this.columnList = res.data.data;
          } else {
            this.utils.messageInfo(this, "error", "查询栏目列表失败！");
          }
        });
    },
    getPublishPlan() {
      this.axios
        .get("/publishPlan/queryPublishPlan", {
          params: {
            year: this.suggestYear,
            notPublished: 1,
            sortField: "total",
            sortType: "asc",
            page: 1,
            limit: 100,
            time: new Date().getTime(),
          },
          paramsSerializer: function (p) {
            return qs.stringify(p, { arrayFormat: "repeat" });
          },
        })
        .then((res) => {
          if (res.data.code == "0") {
            this.planList = res.data.data;
          } else {
            this.utils.messageInfo(this, "error", "查询出版计划列表失败！");
          }
        });
    },
    getSuggest() {
      this.axios
        .get("/manuscripts/getManuscriptsSuggestion", {
          params: { code: this.code },
          paramsSerializer: function (p) {
            return qs.stringify(p, { arrayFormat: "repeat" });
          },
        })
        .then((res) => {
          if (res.data.code == "OK" && res.data.data) {
            this.suggestId = res.data.data.id;
            this.suggestYear = res.data.data.year;
            this.suggestPlan = res.data.data.planCount;
            this.suggestColumn = res.data.data.columnCode;
            this.sectionInfo = res.data.data.sectionInfo;
            this.getColumnList(this.sectionInfo);
          }
        });
    },
    save() {
      if (this.suggestYear == "") {
        this.utils.messageInfo(this, "error", "请选择年份！");
        return;
      }
      if (this.suggestPlan == "") {
        this.utils.messageInfo(this, "error", "请选择建议期次！");
        return;
      }
      if (this.sectionInfo == "") {
        this.utils.messageInfo(this, "error", "请选择版本！");
        return;
      }
      if (this.suggestColumn == "") {
        this.utils.messageInfo(this, "error", "请选择建议栏目！");
        return;
      }
      if (this.suggestId > 0) {
        this.axios
          .post("/manuscripts/updateManuscriptsSuggestion", {
            id: this.suggestId,
            code: this.code,
            year: this.suggestYear,
            planCount: this.suggestPlan,
            columnCode: this.suggestColumn,
            sectionInfo: this.sectionInfo,
            extraInfo: JSON.stringify(this.extraInfo),
            createUser: sessionStorage.getItem("userCode"),
          })
          .then((res) => {
            if (res.data.code == "OK") {
              this.utils.messageInfo(this, "success", "保存成功！");
              this.$router.push("/back");
            } else {
              this.utils.messageInfo(this, "error", "保存失败！");
            }
          });
      } else {
        this.axios
          .post("/manuscripts/saveManuscriptsSuggestion", {
            code: this.code,
            year: this.suggestYear,
            planCount: this.suggestPlan,
            columnCode: this.suggestColumn,
            sectionInfo: this.sectionInfo,
            extraInfo: JSON.stringify(this.extraInfo),
            createUser: sessionStorage.getItem("userCode"),
          })
          .then((res) => {
            if (res.data.code == "OK") {
              this.utils.messageInfo(this, "success", "保存成功！");
              this.$router.push("/back");
            } else {
              this.utils.messageInfo(this, "error", "保存失败！");
            }
          });
      }
    },
  },
};
</script>
<style scoped>
.kongjian {
  height: 100%;
  background-color: #fff;
}
.kongjian .btn_div {
  text-align: center;
  margin-top: 10px;
}
.kongjian .btn_div button {
  margin: 0 5px;
}
.kongjian .title {
  height: 36px;
  line-height: 36px;
  text-align: right;
}
.kongjian .op-row {
  margin-top: 10px;
}
</style>
